<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="supplierApplicationVO.pkId > 0 ? '编辑' : '新建'"
      width="1200px"
      top="2vh"
      @close="dialogClose">
    <el-tabs v-model="defaultTabName">
      <el-tab-pane name="p1" label="基本信息">
        <el-form
            ref="form"
            :model="supplierApplicationVO"
            :rules="ruleValidate"
            class="form"
            label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="编号">
                <el-input v-model="supplierApplicationVO.no" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料开发原因" prop="importReason">
                <el-input v-model="supplierApplicationVO.importReason" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否有替换料" prop="canReplace">
                <el-checkbox-group v-model="canReplace" :max="1" @change="changeCanReplace()">
                  <el-checkbox label="是"/>
                  <el-checkbox label="否"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="客户名称" prop="customerName">
                <el-input v-model="supplierApplicationVO.customerName" placeholder="请选择客户" readonly>
                  <el-button
                      slot="append"
                      icon="el-icon-search"
                      :disabled="supplierApplicationVO.pkid > 0"
                      @click="$refs.selectCustomerName.open()"/>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="成品型号" prop="productSpecification">
                <el-input v-model="supplierApplicationVO.productSpecification" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料名称" prop="materialName">
                <el-input v-model="supplierApplicationVO.materialName" placeholder="请输入"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="物料型号" prop="materialSpecification">
                <el-input v-model="supplierApplicationVO.materialSpecification" placeholder="请输入"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料属性" prop="materialProperty">
                <el-checkbox-group v-model="materialProperty" :max="1" @change="changeMaterialProperty()">
                  <el-checkbox label="A类"/>
                  <el-checkbox label="B类"/>
                  <el-checkbox label="C类"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="物料代码" prop="materialCode">
                <el-input v-model="supplierApplicationVO.materialCode"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="需要符合" prop="standardType">
                <el-checkbox-group v-model="standardType" :max="1" @change="changeStandardType()">
                  <el-checkbox label="RoHS"/>
                  <el-checkbox label="UL"/>
                  <el-checkbox label="客户指定"/>
                  <el-checkbox label="其他要求"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="规格书" prop="specification">
                <el-checkbox-group v-model="specification" :max="1" @change="changeSpecification()">
                  <el-checkbox label="内部使用"/>
                  <el-checkbox label="供方提供承认书"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物料使用类型" prop="useType">
                <el-checkbox-group v-model="useType" :max="1" @change="changeUseType()">
                  <el-checkbox label="项目型使用"/>
                  <el-checkbox label="常规型使用"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <!--            <el-col :span="4">-->
            <!--              <el-form-item label="客户类别" prop="customerLevel">-->
            <!--                <el-select v-model="supplierApplicationVO.customerLevel">-->
            <!--                  <el-option v-for="item in customerLevels" :key="item.value" :label="item.label" :value="item.value"/>-->
            <!--                </el-select>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
          </el-row>
          <el-form-item label="备注">
            <el-input v-model="supplierApplicationVO.note" type="textarea" placeholder="请输入"/>
          </el-form-item>

          <el-row>
            <el-col :span="8">
              <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="supplierApplicationVO.supplierName"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供方联系人" prop="supplierContact">
                <el-input v-model="supplierApplicationVO.supplierContact"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供方联系方式" prop="supplierTel">
                <el-input v-model="supplierApplicationVO.supplierTel"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="供应商性质" prop="supplierType">
                <el-checkbox-group v-model="supplierType" :max="1" @change="changeSupplierType()">
                  <el-checkbox label="生产商"/>
                  <el-checkbox label="代理商"/>
                  <el-checkbox label="其他"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="现有供应商" prop="currentSupplier">
                <el-input v-model="supplierApplicationVO.currentSupplier"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="常规性物料" prop="materialStandard">
                <el-checkbox-group v-model="materialStandard" :max="1"
                                   @change="changeMaterialStandard()">
                  <el-checkbox label="是"/>
                  <el-checkbox label="否"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="与其他物料公用RoHS" label-width="150px" prop="roHS">
                <el-checkbox-group v-model="roHS" :max="1" @change="changeRoHS()">
                  <el-checkbox label="是"/>
                  <el-checkbox label="否"/>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="其他物料" prop="roHSMaterial">
                <el-input v-model="supplierApplicationVO.roHSMaterial"/>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div
            style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
          供方提供资料确认
        </div>
        <div>
          <el-form ref="form"
                   :model="supplierApplicationVO"
                   class="form"
                   style="height: 100px;"
                   label-width="80px">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="supplierApplicationVO.materialProperty" prop="roHSMaterial">
                  <el-checkbox-group v-model="materialPropertyValue" @change="changeMaterialPropertyValue()">
                    <el-checkbox label="营业执照"/>
                    <el-checkbox label="供方调查表"/>
                    <el-checkbox label="质量管理体系"/>
                    <el-checkbox label="不适用有害物质保证函"/>
                    <el-checkbox label="合作协议"/>
                    <el-checkbox label="质量协议"/>
                    <el-checkbox label="UL证书"/>
                    <el-checkbox label="RoHS"/>
                    <el-checkbox label="代理证"/>
                    <el-checkbox label="型式试验(依技术要求)"/>
                    <el-checkbox v-if="supplierApplicationVO.materialProperty!='C类'" label="其他实验要求/盐雾等(依客户要求)"/>
                    <el-checkbox v-if="supplierApplicationVO.materialProperty!='C类'" label="MSDS"/>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane name="p2" label="附件">
        <el-form
            ref="form"
            :model="supplierApplicationVO"
            :rules="ruleValidate"
            class="form"
            label-width="80px">
          <el-row>
            <!--        <el-divider/>-->
            <upload-file
                ref="upload" :disabled="disabled"
                :show-file-list="false"
                :auth-index="authIndex"
                style="text-align: right;margin-top: 2px;"
                @upload-success="uploadSuccess"/>
            <el-table :data="supplierApplicationVO.attachments" height="60vh" border>
              <el-table-column prop="fileName" align="left" label="附件" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.fileName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="creatorName" align="left" label="创建人" width="120">
                <template slot-scope="scope">
                  <span>{{ scope.row.creatorName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" align="left" label="创建时间" width="140">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
                  <el-button type="danger" @click="supplierApplicationVO.attachments.splice(scope.$index, 1)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="p3" label="审批信息"
                   v-if="[20].includes(supplierApplicationVO.status)">
        <el-form
            ref="form"
            :model="supplierApplicationVO"
            class="form"
            label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="测试报告">
                <div style="display: flex">
                  {{ supplierApplicationVO.testReport }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="检验人" prop="testName">
                {{ supplierApplicationVO.testName }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="检验结果" prop="orderStandard">
                {{ supplierApplicationVO.testResult }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="物料是否引入" prop="approveMaterial">
                {{ supplierApplicationVO.approveMaterial }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供方是否引入" prop="approveSupplier">
                {{ supplierApplicationVO.approveSupplier }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资料是否齐全" prop="approveFile">
                {{ supplierApplicationVO.approveFile }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit(0)">保存</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit(1)">保存并提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import constants from "../../../util/constants";
import CustomerSelect from "@/views/information/Customer/CustomerSelect";
import UploadFile from "@/components/UploadFile";
import constant from "@/util/constant";
import MaterialTypeSelector from "@/views/information/MaterialTypeName/MaterialTypeSelector";

export default {
  name: "SupplierApplicationEdit",
  components: {
    CustomerSelect,
    UploadFile,
    MaterialTypeSelector,
  },
  data() {
    return {
      authIndex: 653,
      constants,
      constant,
      positionList: [],
      dialogVisible: false,
      submitLoading: false,
      disabled: false,
      defaultTabName: "p1",
      customerLevels: constant.toSelect(constant.customerLevel),
      productSpecification: [],
      materialProperty: [],
      canReplace: [],
      standardType: [],
      specification: [],
      useType: [],
      supplierType: [],
      materialStandard: [],
      roHS: [],
      materialPropertyValue: [],
      supplierApplicationVO: {
        pkId: 0,
        no: "",
        status: 0,
        importReason: "",
        canReplace: "",
        developerName: "",
        customerName: "",
        productSpecification: "",
        materialName: "",
        materialSpecification: "",
        materialProperty: "",
        materialCode: "",
        standardType: "",
        specification: "",
        useType: "",
        note: "",
        supplierName: "",
        supplierContact: "",
        supplierTel: "",
        supplierType: "",
        roHS: "",
        roHSMaterial: "",
        materialStandard: "",
        currentSupplier: "",
        materialPropertyValue: "",
        testReport: "",
        testName: "",
        testTime: "",
        testResult: "",
        approveMaterial: "",
        approveFile: "",
        approveSupplier: "",
        attachments: [],
      },
      ruleValidate: {
        importReason: {required: true, message: "请输入", trigger: "blur"},
        // customerName: {required: true, message: "请输入客户名称", trigger: "change"},
      },
      ruleValidate0: {},
    };
  },
  methods: {
    open(id, disabled) {
      this.dialogVisible = true;
      this.defaultTabName = "p1";

      this.productSpecification = [];
      this.materialProperty = [];
      this.canReplace = [];
      this.standardType = [];
      this.specification = [];
      this.useType = [];
      this.supplierType = [];
      this.materialStandard = [];
      this.roHS = [];
      this.materialPropertyValue = [];

      if (id > 0) {
        this.supplierApplicationVO.pkId = id;
        this.getData();
      } else {
        this.getNode();
      }
      if (disabled) {
        this.disabled = true;
      }
    },

    getData() {
      this.$http.get("basic", `supplierApplications/${this.supplierApplicationVO.pkId}`).then((resp) => {
        if (resp.success) {
          this.supplierApplicationVO = resp.data;
          this.supplierApplicationVO.canReplace.split(",").forEach((item) => {
            if (item) {
              this.canReplace.push(item);
            }
          });
          this.supplierApplicationVO.productSpecification.split(",").forEach((item) => {
            if (item) {
              this.productSpecification.push(item);
            }
          });
          this.supplierApplicationVO.materialProperty.split(",").forEach((item) => {
            if (item) {
              this.materialProperty.push(item);
            }
          });
          this.supplierApplicationVO.standardType.split(",").forEach((item) => {
            if (item) {
              this.standardType.push(item);
            }
          });
          this.supplierApplicationVO.specification.split(",").forEach((item) => {
            if (item) {
              this.specification.push(item);
            }
          });
          this.supplierApplicationVO.useType.split(",").forEach((item) => {
            if (item) {
              this.useType.push(item);
            }
          });
          this.supplierApplicationVO.supplierType.split(",").forEach((item) => {
            if (item) {
              this.supplierType.push(item);
            }
          });
          this.supplierApplicationVO.materialStandard.split(",").forEach((item) => {
            if (item) {
              this.materialStandard.push(item);
            }
          });
          this.supplierApplicationVO.roHS.split(",").forEach((item) => {
            if (item) {
              this.roHS.push(item);
            }
          });
          this.supplierApplicationVO.materialPropertyValue.split(",").forEach((item) => {
            if (item) {
              this.materialPropertyValue.push(item);
            }
          });
        }
      });
    },
    // 下载
    downLoad(row) {
      this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
        if (res.success) {
          window.open(res.data);
        }
      });
    },
    // 获取编号
    getNode() {
      this.$http.get("basic", "supplierApplications/genNO").then((resp) => {
        if (resp.success) {
          this.supplierApplicationVO.no = resp.data;
        }
      });
    },
    // 选择客户
    selectCustomerName(row) {
      this.supplierApplicationVO.customerId = row.customerID;
      this.supplierApplicationVO.customerName = row.customerName;
      this.supplierApplicationVO.customerNo = row.outerNo;
      this.supplierApplicationVO.customerLevel = row.customerLevel;
    },
    uploadSuccess(fileList) {
      if (fileList.length) {
        const params = {
          fileName: fileList[0].name,
          filePath: fileList[0].key,
        };
        this.supplierApplicationVO.attachments.push(params);
      }
    },

    // 编辑、新建
    handleSubmit(isSave) {
      // this.validValue();

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
              .post("basic", `supplierApplications/save/${isSave}`, this.supplierApplicationVO)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.supplierApplicationVO.pkid > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
        }
      });
    },

    dialogClose() {
      this.dialogVisible = false;
      this.disabled = false;
      this.supplierApplicationVO = {};
      try {
        this.$reset("form");
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    },

    // 物料类型选择
    selectMaterialType(row) {
      this.supplierApplicationVO.materialTypeName = row.name;
      this.supplierApplicationVO.materialTypeId = row.id;
    },
    changeSpecification() {
      this.supplierApplicationVO.specification = "";
      if (this.specification) {
        this.supplierApplicationVO.specification = this.specification.join(",");
      }
    },
    changeUseType() {
      this.supplierApplicationVO.useType = "";
      if (this.useType) {
        this.supplierApplicationVO.useType = this.useType.join(",");
      }
    },
    changeSupplierType() {
      this.supplierApplicationVO.supplierType = "";
      if (this.supplierType) {
        this.supplierApplicationVO.supplierType = this.supplierType.join(",");
      }
    },
    changeMaterialStandard() {
      this.supplierApplicationVO.materialStandard = "";
      if (this.materialStandard) {
        this.supplierApplicationVO.materialStandard = this.materialStandard.join(",");
      }
    },
    changeRoHS() {
      this.supplierApplicationVO.roHS = "";
      if (this.roHS) {
        this.supplierApplicationVO.roHS = this.roHS.join(",");
      }
    },
    changeMaterialPropertyValue() {
      this.supplierApplicationVO.materialPropertyValue = "";
      if (this.materialPropertyValue) {
        this.supplierApplicationVO.materialPropertyValue = this.materialPropertyValue.join(",");
      }
    },
    changeCanReplace() {
      this.supplierApplicationVO.canReplace = "";
      if (this.canReplace) {
        this.supplierApplicationVO.canReplace = this.canReplace.join(",");
      }
    },
    changeMaterialProperty() {
      this.supplierApplicationVO.materialProperty = "";
      this.supplierApplicationVO.materialPropertyValue="";
      this.materialPropertyValue=[];
      if (this.materialProperty) {
        this.supplierApplicationVO.materialProperty = this.materialProperty.join(",");
      }
    },
    changeStandardType() {
      this.supplierApplicationVO.standardType = "";
      if (this.standardType) {
        this.supplierApplicationVO.standardType = this.standardType.join(",");
      }
    },
    changeP10Chicun() {
      this.p10.chicun_10 = "";
      if (this.p10.listChicun_10) {
        this.p10.chicun_10 = this.p10.listChicun_10.join(",");
      }
    },

    //p40
    changeP40Lianjie() {
      this.p40.lianjie_40 = "";
      if (this.p40.listLianjie_40) {
        this.p40.lianjie_40 = this.p40.listLianjie_40.join(",");
      }
    },

    //p50
    changeP50Renzheng() {
      this.p50.renzheng_50 = "";
      if (this.p50.listRenzheng_50) {
        this.p50.renzheng_50 = this.p50.listRenzheng_50.join(",");
      }
    },
    changeP50Dianzu() {
      this.p50.dianzuleixing_50 = "";
      if (this.p50.listDianzuleixing_50) {
        this.p50.dianzuleixing_50 = this.p50.listDianzuleixing_50.join(",");
      }
    },
    changeP50Xiangti() {
      this.p50.xiangti_50 = "";
      if (this.p50.listXiangti_50) {
        this.p50.xiangti_50 = this.p50.listXiangti_50.join(",");
      }
    },

  },
};
</script>

<style>
.error-label .el-form-item__label {
  color: #f56c6c;
  transition: color 0.3s;
}

.myLabelStyle {
  color: #f56c6c;
}
</style>
